// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divcommonraccourcis
{
    background-color: transparent;
    margin-top: 5px;
    width: 100%;
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/allsettings/commonraccourcis/commonraccourcis.css"],"names":[],"mappings":"AAAA;;IAEI,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,YAAY;AAChB","sourcesContent":[".divcommonraccourcis\n{\n    background-color: transparent;\n    margin-top: 5px;\n    width: 100%;\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
